import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
} from "@mui/material";

const defaults = {
  fromWeight: 0,
  toWeight: 0,
  ratePerKg: 0,
  minCharge: 0,
};

const SlabDialog = ({ open, onOpenChange, onSubmit, initial, title }) => {
  const [form, setForm] = useState(initial || defaults);

  const handleOpen = () => setForm(initial || defaults);

  const setNum = (key, val) =>
    setForm({ ...form, [key]: parseFloat(val) || 0 });

  const handleSubmit = () => {
    if (form.toWeight <= form.fromWeight || form.ratePerKg <= 0) return;
    onSubmit(form);
    onOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => onOpenChange(false)}
      slotProps={{ transition: { onEnter: handleOpen } }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid size={6}>
            <TextField
              label="From Weight (kg)"
              type="number"
              value={form.fromWeight}
              onChange={(e) => setNum("fromWeight", e.target.value)}
              size="small"
              fullWidth
              slotProps={{ htmlInput: { min: 0, step: 0.1 } }}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              label="To Weight (kg)"
              type="number"
              value={form.toWeight}
              onChange={(e) => setNum("toWeight", e.target.value)}
              size="small"
              fullWidth
              slotProps={{ htmlInput: { min: 0, step: 0.1 } }}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              label="Rate/kg (₹)"
              type="number"
              value={form.ratePerKg}
              onChange={(e) => setNum("ratePerKg", e.target.value)}
              size="small"
              fullWidth
              slotProps={{ htmlInput: { min: 0, step: 1 } }}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              label="Min Charge (₹)"
              type="number"
              value={form.minCharge}
              onChange={(e) => setNum("minCharge", e.target.value)}
              size="small"
              fullWidth
              slotProps={{ htmlInput: { min: 0, step: 1 } }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={
            form.toWeight <= form.fromWeight || form.ratePerKg <= 0
          }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SlabDialog;
